import { Profile } from '../types/profile';

// We enrich the profile with the subscriber property, but we don't want to send it to bff in some cases
export const cleanProfileKeys = (profile: Profile): Omit<Profile, 'subscriber'> => {
  const { subscriber, ...adaptedProfile } = profile;
  return adaptedProfile;
};
